const VIDEO_URL =
  'https://s3-figma-videos-production-sig.figma.com/video/680413385258611204/TEAM/25ec/040e/-b5a3-4457-9b74-9e71c3353e59?Expires=1734307200&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=hQNf2qJ3QvmUq57aB~MwcUer1guM4TI2pdiEXpdceiqkMC2TDMHc6HC9vmjR0bJSSyVxb7A3C-rxyy~LKHTBQrFxGiIbpvkT50TuDSiMqsa5l8H7C7zi8lCxQ1P8pAZRpB1MqOmSngvUdm74OV4VVL6x4T4lEk2KUva1Q2dtLcDC02o8vwxJVHP1lgtMAbBMEaQNvxRucjh4PqyfV4YU~Ldt3idVw8s5k4NdwFpUrEMt4yTYld4byv7dA9gDUnbW7SM7rO9mwepqoBJS3xrq5wjHyvsprBon-Azz8tBf62gSkdjtKQvdKZfBAEjr3XY24vQufB5rd6V5T~ROnf0-KA__';

export const LoadingIndicator = () => {
  return (
    <video
      className="w-24 md:-translate-x-1/2"
      src={VIDEO_URL}
      autoPlay
      loop
      muted
    />
  );
};
